import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-currency-icon',
  templateUrl: './currency-icon.component.html',
  styleUrls: ['./currency-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyIconComponent implements OnChanges {
  @Input({ required: true }) icon!: string;
  @Input() sizeCss = '--icon-medium';

  iconSrc = '';
  iconStyles: Record<string, string> = {};

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateIconSrc();
    this.updateIconStyles();
  }

  private updateIconSrc(): void {
    this.iconSrc = `assets/images/currency/${this.icon}.svg`;
  }

  private updateIconStyles(): void {
    this.iconStyles = {
      color: 'var(--white-grey)',
      'font-size': `var(${this.sizeCss})`,
    };
  }
}
